import { RTKQueryTag } from 'src/common/constants';
import { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';
import { AWSCredentialsResponse, AWSRoomEnvironmentDetailsResponse } from 'src/common/interfaces/rooms/cloud/aws';

export const extendedRoomAwsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAwsCredentials: builder.query<ApiResponse<AWSCredentialsResponse>, void>({
      query: () => ({
        url: 'rooms/cloud/aws/credentials',
        method: 'GET',
      }),
      providesTags: [RTKQueryTag.CloudAwsEnvCredentials],
    }),
    getAwsEnvDetails: builder.query<ApiResponse<AWSRoomEnvironmentDetailsResponse>, string>({
      query: (roomId) => ({
        url: `rooms/cloud/aws/env/details?roomId=${roomId}`,
        method: 'GET',
      }),
      providesTags: [RTKQueryTag.CloudAwsEnvDetails],
    }),
    postAwsEnvReset: builder.mutation<ApiResponse<string>, void>({
      query: () => ({
        url: 'rooms/cloud/aws/env/reset',
        method: 'POST',
      }),
      invalidatesTags: (result, error) => (!error && result ? [{ type: RTKQueryTag.CloudAwsEnvDetails }] : []),
    }),
    postAwsGenerateEnvironment: builder.mutation<ApiResponse<string>, string>({
      query: (roomId) => {
        if (!roomId) throw new Error('Invalid roomId');
        return {
          url: 'rooms/cloud/aws/env/generate',
          method: 'POST',
          body: { roomId },
        };
      },
      invalidatesTags: (result, error) => (!error && result ? [{ type: RTKQueryTag.CloudAwsEnvDetails }] : []),
    }),
  }),
});

export const {
  useGetAwsCredentialsQuery,
  useLazyGetAwsCredentialsQuery,
  useGetAwsEnvDetailsQuery,
  useLazyGetAwsEnvDetailsQuery,
  usePostAwsEnvResetMutation,
  usePostAwsGenerateEnvironmentMutation,
} = extendedRoomAwsApiSlice;
